import { FC } from 'react';

import { Dropdown } from '@shared';
import { toLangCode } from '@utils/routeHelpers';
import i18n from 'i18next';

import { TLanguage } from '../../../../general/_models/general';
import { useGetLanguage } from '../../../../general/_queries/useGetLanguage';

import './languagePickerDropdown.scss';

type TProps = {
  languages: TLanguage[];
};

const LanguagePickerDropdown: FC<TProps> = ({ languages }) => {
  if (!languages) return null;

  const { refetch: refetchTranslations } = useGetLanguage();

  function handleChange(shortCode: string) {
    // Map short code back to full locale for i18next + translations
    const fullCode = languages.find(l => toLangCode(l.code) === shortCode)?.code ?? shortCode;
    i18n.changeLanguage(fullCode);
    localStorage.setItem('preferredLanguage', fullCode);
    refetchTranslations();

    // Update the URL basename segment (clientType/lang/...rest)
    const urlSegments = window.location.pathname.split('/').filter(s => s);
    const clientType = urlSegments[0];
    const remainingSegments = urlSegments.slice(2);
    const newPath = `/${[clientType, shortCode, ...remainingSegments].join('/')}`;
    window.location.replace(newPath);
  }

  return (
    <Dropdown
      className="header__languagepicker"
      hasNoEmtyOption
      isSearchable={false}
      name="Language"
      onChange={handleChange}
      options={languages.map(language => ({ label: toLangCode(language.code).toUpperCase(), value: toLangCode(language.code) }))}
      value={toLangCode(i18n.language)}
    />
  );
};

export default LanguagePickerDropdown;
